// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { getTags, addNewPerson, uploadFile } from "../../actions/faceActions";
import {
  dbAddPerson,
  updatePerson,
  setPeopleFormError
} from "../../actions/peopleActions";
import CreatePersonForm from "../../components/people/CreatePersonForm";
import ChipInput from "../../../global/components/ChipInput";
import { EnrolmentType } from "../../../global/types/FaceType";
import type { EnrolmentInputModel } from "../../types/InputModels";
type CreatePersonFormReduxPropsType = {
  onClose: Function,
  setMessage: Function,
  enrolments?: Array<EnrolmentType>,
  newEnrolments?: EnrolmentInputModel[],
  name?: string,
  tags?: Array<string>,
  fromDb?: boolean,
  isEdit?: boolean,
  uid?: string
};

class CreatePersonFormRedux extends Component<
  CreatePersonFormReduxPropsType,
  *
> {
  componentDidMount() {
    this.props.actions.setPeopleFormError(null);
    this.props.actions.getTags();
  }

  render(): * {
    return (
      <CreatePersonForm
        onClose={this.props.onClose}
        setMessage={this.props.setMessage}
        enrolments={this.props.enrolments}
        newEnrolments={this.props.newEnrolments}
        name={this.props.name}
        tags={this.props.tags}
        tagList={this.props.tagList}
        fromDb={this.props.fromDb}
        isEdit={this.props.isEdit}
        uid={this.props.uid}
        faceSearch={this.props.faceSearch}
        addNewPerson={this.props.actions.addNewPerson}
        updatePerson={this.props.actions.updatePerson}
        dbAddPerson={this.props.actions.dbAddPerson}
        uploadFile={this.props.actions.uploadFile}
        ChipInput={ChipInput}
      />
    );
  }
}

const mapStateToProps = (state: stateProps): * => ({
  faceSearch: state.v3account.faceSearch,
  tagList: state.v3account.db.tagList
  // tags: state.v3account.db.tagList
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      getTags,
      addNewPerson,
      dbAddPerson,
      updatePerson,
      uploadFile,
      setPeopleFormError
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePersonFormRedux);
